<template>
  <v-card class="back" style="height: 480px">
    <v-layout column fill-height>
      <scroll-area>
        <template slot="header">
          <v-toolbar dark color="secondary" dense>
            <v-toolbar-title>
              <span class="body-2 text-uppercase">{{$t('rules')}} {{$t(data.name)}}</span>
            </v-toolbar-title>
          </v-toolbar>
        </template>

        <template slot="body">
          <v-layout column fill-height justify-start>
            <v-flex shrink v-for="(rule, index) in getRules" :key="index">
              <v-layout fill-height pt-1>
                <v-flex xs5 pa-1>
                  <v-textarea
                    :data-testid="$options.name + '__textarea__' + 'rule.expression__' + index"
                    v-model="rule.expression"
                    light
                    auto-grow
                    solo
                    background-color="back darken-1"
                    flat
                    :hint="$t('expression')"
                    persistent-hint
                    rows="1"
                  ></v-textarea>
                </v-flex>

                <v-flex xs2 pa-1>
                  <v-select
                    :data-testid="$options.name + '__select__' + 'rule.state' + index"
                    v-model="rule.state"
                    light
                    auto-grow
                    :items="states"
                    :label="$t('state')"
                    solo
                    background-color="back darken-1"
                    flat
                    rows="1"
                    height="45"
                  ></v-select>
                </v-flex>

                <v-flex xs5 pa-1>
                  <v-textarea
                    :data-testid="$options.name + '__textarea__' + 'rule.description' + index"
                    v-model="rule.description"
                    light
                    auto-grow
                    solo
                    background-color="back darken-1"
                    flat
                    :hint="$t('description')"
                    persistent-hint
                    rows="1"
                  ></v-textarea>
                </v-flex>

                <v-flex shrink pt-1>
                  <v-btn :data-testid="$options.name + '__btn__' + 'close'" icon color="primary">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>

        <template slot="footer">
          <v-layout fill-height>
            <v-flex xs2>
              <v-btn small 
              :data-testid="$options.name + '__btn__' + 'addRule'"
              @click="()=>{addRule()}" color="secondary">добавить правило</v-btn>
            </v-flex>
            <v-layout fill-height justify-end>
              <v-btn dark small 
              :data-testid="$options.name + '__btn__' + 'close'"
              @click="()=>{$emit('close')}" color="grey">{{$t('cancel')}}</v-btn>
              <v-btn small 
              :data-testid="$options.name + '__btn__' + 'save'"
              @click="" color="secondary">{{$t('save')}}</v-btn>
            </v-layout>
          </v-layout>
        </template>
      </scroll-area>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы
interface RuleItem {
  expression: string | null
  state: string | null
  description: string | null
}

interface PreferencesData {
  [key: string]: any
}

export default Vue.extend({
  name: 'PREFERENCES_CARD',

  components: {
    scrollArea
  },

  props: {
    data: {
      type: Object as () => PreferencesData,
      default: () => ({})
    },
  },

  data(): {
    param: PreferencesData | null
    states: string[]
    rules: RuleItem[]
    rule: RuleItem
  } {
    return {
      param: null,
      states: ['warning', 'alarm'],
      rules: [
        {
          expression: null,
          state: null,
          description: null,
        }
      ],
      rule: {
        expression: null,
        state: null,
        description: null,
      },
    }
  },

  computed: {
    getRules(): RuleItem[] {
      // Создаём копию массива перед reverse, чтобы не мутировать оригинал
      return [...this.rules].reverse()
    }
  },

  created(): void {
    console.log(this.$options.name, 'param', this.data)
    this.param = this.data
  },

  methods: {
    addRule(): void {
      this.rules.push({
        expression: null,
        state: null,
        description: null,
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
